import { useState } from 'react';
import { useSelector } from 'react-redux';

import appSelectors from '@/redux/app/appSelectors';

import useMatchMedia from '@/hooks/useMatchMedia';

import RightIcon from '@/images/right.svg?react';

import Container from '@/components/container';

import Logo from './logo';
import BtnLang from './btnLang';
import BtnMenu from './btnMenu';
import Menu from './menu';
import Nav from './nav';

import s from './header.module.css';

const ACC_URL = import.meta.env.VITE_ACC_URL;

function Header() {
  const i18n = useSelector(appSelectors.translation);
  const lang = useSelector(appSelectors.language);
  const refCode = useSelector(appSelectors.refCode);

  const [displayMenu, setDisplayMenu] = useState(false);
  const toggleMenu = () => setDisplayMenu(!displayMenu);

  const { isMobile, isDesktop } = useMatchMedia();

  const loginUrl = refCode
    ? `${ACC_URL}/login?lang=${lang}&ref=${refCode}`
    : `${ACC_URL}/login?lang=${lang}`;

  const signupUrl = refCode
    ? `${ACC_URL}/signup?lang=${lang}&ref=${refCode}`
    : `${ACC_URL}/signup?lang=${lang}`;

  return (
    <>
      <header className={s.header}>
        <Container>
          <Logo />

          <BtnLang />

          {isDesktop && <Nav />}

          {!isMobile && (
            <a
              href={loginUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={s.btn_login}
            >
              {i18n.вход}
              <RightIcon />
            </a>
          )}

          {!isMobile && (
            <a
              href={signupUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={s.btn_signup}
            >
              {i18n.регистрация}
            </a>
          )}

          {!isDesktop && <BtnMenu onClick={toggleMenu} />}
        </Container>
      </header>

      {displayMenu && !isDesktop && <Menu close={toggleMenu} />}
    </>
  );
}

export default Header;
